import React from 'react';
import { Phone, Target, TrendingUp } from 'lucide-react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const Process = ({ config = {} }) => {
  const [ref, isVisible] = useScrollAnimation();
  
  const defaultSteps = [
    {
      icon: Phone,
      title: 'Contacto inicial',
      description: 'Contáctanos por WhatsApp y te responderemos personalmente para conocer tu perfil y evaluar tu potencial en la industria.',
      image: 'https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/2vcae96x_IMG_6786.JPG'
    },
    {
      icon: Target,
      title: 'Estrategia personalizada',
      description: 'Desarrollamos un plan a medida para ti, preparamos tu perfil profesionalmente y nos encargamos de toda la configuración necesaria.',
      image: 'https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/nr38ljsv_IMG_6787.JPG'
    },
    {
      icon: TrendingUp,
      title: 'Crecimiento continuo',
      description: 'Desde el primer día te acompañamos estratégicamente: gestionamos chats, planificamos contenido y potenciamos tus ingresos con JG Models.',
      image: 'https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/tahybhtf_IMG_8733.JPEG'
    }
  ];
  
  const steps = config.processSteps || defaultSteps;
  const processTitle = config.processTitle || 'Nuestro Proceso';
  const processSubtitle = config.processSubtitle || 'Una colaboración simple y transparente en solo tres pasos.';

  return (
    <section ref={ref} id="proceso" className="py-24 bg-black">
      <div className="container mx-auto px-4">
        <div className={`text-center mb-16 fade-in ${isVisible ? 'visible' : ''}`}>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {processTitle}
          </h2>
          <p className="text-gray-400 text-lg font-light">
            {processSubtitle}
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, index) => {
              // Manejar tanto íconos como componentes
              const iconMap = { Phone, Target, TrendingUp };
              const Icon = typeof step.icon === 'string' ? iconMap[step.icon] : step.icon;
              const IconComponent = Icon || Phone;
              return (
                <div
                  key={index}
                  className={`relative group stagger-item delay-${(index + 2) * 100} ${isVisible ? 'visible' : ''}`}
                >
                  {/* Connecting Line */}
                  {index < steps.length - 1 && (
                    <div className="hidden md:block absolute top-16 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-[#c8784e] to-transparent z-30" />
                  )}
                  
                  <div className="relative bg-[#1d1e20] p-8 rounded-2xl hover:bg-[#252628] transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-[#c8784e]/20 h-full overflow-hidden">
                    {/* Background Image */}
                    <div className="absolute inset-0 opacity-35 group-hover:opacity-45 transition-opacity duration-500 z-0">
                      <img src={step.image} alt={step.title} className="w-full h-full object-cover" />
                    </div>
                    
                    {/* Dark Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/50 z-5" />
                    
                    <div className="relative z-10">
                      <div className="bg-[#c8784e]/10 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                        <IconComponent size={32} className="text-[#c8784e]" />
                      </div>
                      
                      <h3 className="text-2xl font-bold mb-4 text-white">{step.title}</h3>
                      <p className="text-gray-300 leading-relaxed font-light">{step.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;